module.exports = __webpack_public_path__ + "img/qr-scan_s.03c6568c.svg";